import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccountCommonModule } from '@inyova/account-common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { HomeEffects } from './home.effects';

import { SharedModule } from '@shared/shared.module';

import * as fromComponents from './components';
import { HomePageRoutingModule } from './home-routing.module';
import { HomePageComponent } from './home.page';
import * as fromModals from './modals';
import * as allReducers from './reducers/index';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    EffectsModule.forFeature([HomeEffects]),
    HomePageRoutingModule,
    StoreModule.forFeature(allReducers.IMPACT_REDUCER_FEATURE_KEY, allReducers.fromImpact.reducerImpact),
    StoreModule.forFeature(allReducers.HOME_REDUCER_FEATURE_KEY, allReducers.fromHome.reducerHome),
    StoreModule.forFeature(allReducers.PERFORMANCE_REDUCER_FEATURE_KEY, allReducers.fromPerformance.reducerPerformance),
    TranslateModule,
    AccountCommonModule
  ],
  declarations: [HomePageComponent, ...fromComponents.components, ...fromModals.components],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HomePageModule {}
